/**
 * Modular PDP — FloFit flavor selector (flofitprov2 / flofit-v2 only).
 * Syncs flavor choice with buy box variant and form hidden inputs.
 */
(function (doc, win) {
  'use strict';

  var flavorRoot = doc.querySelector('[data-modular-flavor-selector]');
  if (!flavorRoot) return;

  var hero = doc.querySelector('[data-pcos-hero]');
  if (!hero) return;

  var variantsEl = doc.getElementById('pdp-all-variants-data');
  if (!variantsEl) return;

  var variantsData;
  try {
    variantsData = JSON.parse(variantsEl.textContent);
  } catch (e) {
    return;
  }

  var flavorButtons = Array.prototype.slice.call(
    flavorRoot.querySelectorAll('[data-modular-flavor-option]')
  );
  if (!flavorButtons.length) return;

  var qtyButtons = Array.prototype.slice.call(
    hero.querySelectorAll('[data-variant-option][data-flofit-quantity]')
  );

  var variants = variantsData.variants || [];
  var currentFlavor =
    (flavorRoot.querySelector('.modular-pdp-flavor__option.is-active') || flavorButtons[0])
      .getAttribute('data-flavor') || '';

  function normalize(str) {
    return String(str || '').toLowerCase().trim();
  }

  function hasQuantity(value, quantity) {
    var s = normalize(value);
    var q = String(quantity);
    if (!s) return false;
    return (
      s === q ||
      s.indexOf(q + ' ') === 0 ||
      s.indexOf(' ' + q + ' ') !== -1 ||
      s.indexOf(' ' + q) === s.length - (q.length + 1)
    );
  }

  function isOneTubOption(value) {
    var s = normalize(value);
    return s === '1 tub' || s.indexOf('1 tub') !== -1;
  }

  function flavorOptionMatches(optionValue, flavor) {
    var option = String(optionValue || '').trim();
    var target = String(flavor || '').trim();
    if (!option || !target) return false;
    return option === target || normalize(option) === normalize(target);
  }

  function findOneTubVariant(flavor) {
    if (!flavor) return null;

    var exact = variants.find(function (v) {
      if (flavorOptionMatches(v.option1, flavor) && isOneTubOption(v.option2)) return true;
      if (flavorOptionMatches(v.option2, flavor) && isOneTubOption(v.option1)) return true;
      return false;
    });
    if (exact) return exact;

    var flavorLower = normalize(flavor);
    return (
      variants.find(function (v) {
        var title = normalize(v.title);
        return title.indexOf(flavorLower) !== -1 && title.indexOf('1 tub') !== -1;
      }) || null
    );
  }

  function variantMatches(variant, quantity, flavor) {
    var flavorLower = normalize(flavor);
    var qStr = String(quantity);
    var title = normalize(variant.title);
    var o1 = normalize(variant.option1);
    var o2 = normalize(variant.option2);

    if (
      title.indexOf(flavorLower) !== -1 &&
      (title.indexOf(qStr + ' tub') !== -1 ||
        title.indexOf(qStr + '-pack') !== -1 ||
        title.indexOf(qStr + ' month') !== -1 ||
        title === qStr)
    ) {
      return true;
    }

    if (
      (o1.indexOf(flavorLower) !== -1 && hasQuantity(o2, qStr)) ||
      (o2.indexOf(flavorLower) !== -1 && hasQuantity(o1, qStr))
    ) {
      return true;
    }

    var flavorWords = flavorLower.split(/\s+/).filter(function (w) {
      return w.length > 2;
    });
    var hasQty =
      hasQuantity(o1, qStr) ||
      hasQuantity(o2, qStr) ||
      title.indexOf(qStr + ' tub') !== -1 ||
      title.indexOf(qStr + '-pack') !== -1 ||
      title.indexOf(qStr + ' month') !== -1;

    if (!hasQty) return false;

    return flavorWords.some(function (w) {
      return title.indexOf(w) !== -1 || o1.indexOf(w) !== -1 || o2.indexOf(w) !== -1;
    });
  }

  function findVariant(quantity, flavor) {
    return (
      variants.find(function (v) {
        return variantMatches(v, quantity, flavor);
      }) || null
    );
  }

  function applyVariantToButton(btn, variant) {
    if (!btn || !variant) return false;
    btn.dataset.variantId = variant.id;
    btn.dataset.variantPriceCents = variant.price || 0;
    btn.dataset.variantComparePriceCents = variant.compare_at_price || variant.price || 0;
    btn.dataset.variantDays = variant.days || 30;
    btn.dataset.variantSubscribePriceCents = variant.subscribe_price || 0;
    btn.dataset.variantSubscribeComparePriceCents = variant.subscribe_compare || variant.price || 0;
    btn.dataset.variantSubscribePolicyPct = variant.subscribe_policy_pct || 0;
    btn.dataset.variantSellingPlanId = variant.selling_plan_id || '';
    btn.dataset.variantAvailable = variant.available ? 'true' : 'false';
    btn.dataset.variantFeaturedImageId = variant.featured_image_id || '';
    return true;
  }

  function syncBuyBoxAndForm(variant) {
    if (!variant) return;
    var vid = String(variant.id);
    var form = hero.querySelector('[data-nnh-form]');
    if (form) {
      var variantInput = form.querySelector('[data-nnh-variant-id]');
      if (variantInput) variantInput.value = vid;
    }
    var buyBox = hero.querySelector('[data-nnh-buy-box]');
    if (buyBox) {
      buyBox.dataset.oneMonthVariantId = vid;
      Array.prototype.forEach.call(
        buyBox.querySelectorAll('[data-nnh-buy-box-card]'),
        function (card) {
          var tier = (card.dataset.tier || '').toLowerCase();
          if (tier === 'quarterly') {
            var quarterlyVariant = findVariant(3, currentFlavor);
            card.dataset.variantId = quarterlyVariant
              ? String(quarterlyVariant.id)
              : vid;
          } else {
            card.dataset.variantId = vid;
          }
        }
      );
      var atcBtn = buyBox.querySelector('[data-nnh-buy-box-atc]');
      if (atcBtn) {
        var selectedCard = buyBox.querySelector(
          '[data-nnh-buy-box-card][aria-pressed="true"]'
        );
        var selectedVariantId =
          selectedCard && selectedCard.dataset.variantId
            ? selectedCard.dataset.variantId
            : vid;
        atcBtn.dataset.variantId = selectedVariantId;
        atcBtn.disabled = !variant.available;
      }
    }
    try {
      var url = new URL(win.location.href);
      url.searchParams.set('variant', vid);
      win.history.replaceState({}, '', url);
    } catch (e) {}
    doc.dispatchEvent(new CustomEvent('pdp-hero-gallery:sync-context'));
  }

  function resetBuyBoxToQuarterly() {
    var buyBox = hero.querySelector('[data-nnh-buy-box]');
    if (!buyBox) return;
    var quarterlyCard = buyBox.querySelector('[data-nnh-buy-box-card][data-tier="quarterly"]');
    if (quarterlyCard) quarterlyCard.click();
  }

  function getActiveQtyButton() {
    return qtyButtons.find(function (btn) {
      return btn.classList.contains('is-active');
    }) || qtyButtons[0];
  }

  function refreshQtyButtons() {
    qtyButtons.forEach(function (btn) {
      var quantity = btn.getAttribute('data-flofit-quantity');
      var variant = findVariant(quantity, currentFlavor);
      if (variant) applyVariantToButton(btn, variant);
    });
  }

  function activateQtyButton(btn) {
    if (!btn) return;
    qtyButtons.forEach(function (item) {
      item.classList.remove('is-active');
    });
    btn.classList.add('is-active');
    btn.click();
  }

  function selectFlavor(button) {
    var flavor = button.getAttribute('data-flavor');
    if (!flavor) return;

    currentFlavor = flavor;
    flavorButtons.forEach(function (btn) {
      var active = btn === button;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var oneMonthVariant = findOneTubVariant(currentFlavor);
    syncBuyBoxAndForm(oneMonthVariant);
    resetBuyBoxToQuarterly();

    if (qtyButtons.length) {
      refreshQtyButtons();
      activateQtyButton(getActiveQtyButton());
    }

    doc.dispatchEvent(
      new CustomEvent('flavorChanged', {
        detail: { flavor: currentFlavor }
      })
    );

    try {
      sessionStorage.setItem('selectedFlavor', currentFlavor);
    } catch (e) {}
  }

  flavorButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      selectFlavor(button);
    });
  });

  if (qtyButtons.length) {
    refreshQtyButtons();
  }

  var urlVariantId = null;
  try {
    urlVariantId = new URLSearchParams(win.location.search).get('variant');
  } catch (e) {}

  var flavorSelectedFromUrlOrStorage = false;

  if (urlVariantId && win.getVariantInfoFromVariantId) {
    var info = win.getVariantInfoFromVariantId(urlVariantId);
    if (info && info.flavor) {
      flavorButtons.forEach(function (btn) {
        var btnFlavor = normalize(btn.getAttribute('data-flavor'));
        var infoFlavor = normalize(info.flavor);
        if (
          btnFlavor === infoFlavor ||
          btnFlavor.indexOf(infoFlavor) !== -1 ||
          infoFlavor.indexOf(btnFlavor) !== -1
        ) {
          selectFlavor(btn);
          flavorSelectedFromUrlOrStorage = true;
        }
      });
    }
  } else {
    try {
      var saved = sessionStorage.getItem('selectedFlavor');
      if (saved) {
        flavorButtons.forEach(function (btn) {
          if (btn.getAttribute('data-flavor') === saved) {
            selectFlavor(btn);
            flavorSelectedFromUrlOrStorage = true;
          }
        });
      }
    } catch (e) {}
  }

  if (!flavorSelectedFromUrlOrStorage) {
    syncBuyBoxAndForm(findOneTubVariant(currentFlavor));
    doc.dispatchEvent(
      new CustomEvent('flavorChanged', {
        detail: { flavor: currentFlavor }
      })
    );
  }

  setTimeout(function () {
    syncBuyBoxAndForm(findOneTubVariant(currentFlavor));
  }, 350);

  win.getSelectedFlavor = function () {
    return currentFlavor;
  };
})(document, window);
